import cloneDeep from 'lodash.clonedeep';
import { select, put, PutEffect, SelectEffect } from 'redux-saga/effects';

import {
  LockElementsAction,
  UnlockElementsAction,
  LOCK_ELEMENTS,
  updateScribe,
  LockActiveElementsAction,
  UnlockActiveElementsAction,
  LOCK_ACTIVE_ELEMENTS,
  lockElements,
  unlockElements
} from 'js/actionCreators/scribeActions';

import { getActiveElements, getScribeById } from '../selectors';

export function* updateElementsLock({
  type,
  elementIds,
  scribeId
}: LockElementsAction | UnlockElementsAction): Generator<
  SelectEffect | PutEffect,
  void,
  ReturnType<typeof getScribeById>
> {
  const lockFlag = type === LOCK_ELEMENTS;
  const elementsToUpdate = Array.isArray(elementIds) ? elementIds : [elementIds];

  const scribe = yield select(state => getScribeById(state, scribeId));

  if (scribe) {
    const scribeClone = cloneDeep(scribe);
    scribeClone.elements.forEach(el => {
      if (elementsToUpdate.includes(el.id)) {
        el.locked = lockFlag;
      }
    });

    yield put(updateScribe(scribeClone));
  }
}

export function* updateLockOnActiveElements({
  type,
  scribeId,
  eventTrigger
}: LockActiveElementsAction | UnlockActiveElementsAction) {
  const actionCreator = type === LOCK_ACTIVE_ELEMENTS ? lockElements : unlockElements;
  const activeElements = (yield select(getActiveElements)) as ReturnType<typeof getActiveElements>;
  yield put(actionCreator(activeElements, scribeId, eventTrigger));
}
